import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { insertIntoString } from '../Utils/Other';
import { asString } from '../Utils/ValueUtils';
import { formatterStrParam } from '../Utils/ParamUtils';

class TEDDisplayBankgiroNr extends BaseDisplayer {
  public static getInstance(): TEDDisplayBankgiroNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayBankgiroNr;

  defaultParams(): string {
    return `ONSep="-"`;
  }

  display(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    let valAsStr = asString(value) || '';

    const { result, value: onSep } = formatterStrParam(
      'ONSep',
      params,
      this.defaultParams()
    );

    if (result) {
      valAsStr = insertIntoString(onSep, valAsStr, valAsStr.length - 4);
    }

    return valAsStr;
  }
}

export { TEDDisplayBankgiroNr };
